<template>
  <div
    class="comment p-2"
    @click.stop>
    <div>
      <textarea
        v-model="commentInput"
        class="form-control"
        placeholder="コメントを入力してください。"
        rows="5" />
      <validation-observer v-slot="{passes}">
        <div class="general-form__group form-group mt-3 mt-md-4">
          <validation-provider
            v-if="attachmentOption"
            v-slot="v"
            rules="file_size">
            <file-uploader
              v-model="file" />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
        <button
          class="btn btn-l-blue btn-block mt-3"
          @click="passes(onClickAddComment)">
          コメントを追加
        </button>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FileUploader from '@/components/parts/FileUploader'

export default {
  components: {
    FileUploader
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    refetchEvent: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      commentInput: '',
      file: null
    }
  },
  computed: {
    ...mapGetters('tenant', ['attachmentOption']),
    ...mapGetters('auth', ['isManager']),
  },
  methods: {
    async onClickAddComment() {
      const latestEvent = await this.refetchEvent(this.eventId)
      if (!latestEvent) {
        this.$store.commit('notify/set', {message: 'この予定は削除されました', type: 'danger'})
        return
      }
      if (this.commentInput && this.commentInput !== '' || this.file){
        if (this.isManager) {
          if (latestEvent.isDraft) {
            if (!window.confirm('下書き予定表へのコメントはあなたをフォローする管理者にだけ通知されます')) return
          } else {
            if (!window.confirm('予定表へのコメントはあなたをフォローするすべてのユーザーに通知されます')) return
          }
        } else {
          if (latestEvent.isDraft) {
            this.$store.commit('notify/set', {message: '予定が下書き状態になったためコメントを送信できませんでした', type: 'danger'})
            return
          } else {
            if (!window.confirm('予定表へのコメントはこの予定の作者にだけ通知されます')) return
          }
        }
        this.$emit('create', this.eventId, this.commentInput, this.file)
        this.commentInput = ''
        this.file = null
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.comment{
  background-color: $grey15;
}
</style>